// @ts-nocheck
// Pharmashop24 — Consolidated JS
// Cart AJAX, mega menu, quiz modal, wishlist (localStorage)

document.addEventListener('DOMContentLoaded', () => {

  /* ── Helpers ────────────────────────────────────────────── */

  function syncSummaryState() {
    const consent = document.getElementById('cart-consent');
    const link    = document.getElementById('summary-link');
    if (!consent || !link) return;
    const ok = consent.checked;
    link.classList.toggle('disabled', !ok);
    link.setAttribute('aria-disabled', String(!ok));
  }

  function updateCartBadge(count) {
    const badge = document.querySelector('#cart-trigger .badge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'grid' : 'none';
  }

  /* ── Cart drawer open / close ───────────────────────────── */

  const cartDrawer   = document.getElementById('cart-drawer');
  const cartBackdrop = document.getElementById('cart-backdrop');
  const cartTrigger  = document.getElementById('cart-trigger');

  function openCartDrawer() {
    closeMegaMenu();
    closeMobileNav();
    if (cartDrawer)   { cartDrawer.classList.add('open');   cartDrawer.setAttribute('aria-hidden', 'false'); }
    if (cartBackdrop) { cartBackdrop.classList.add('open'); }
    if (cartTrigger)  { cartTrigger.setAttribute('aria-expanded', 'true'); }
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer)   { cartDrawer.classList.remove('open');   cartDrawer.setAttribute('aria-hidden', 'true'); }
    if (cartBackdrop) { cartBackdrop.classList.remove('open'); }
    if (cartTrigger)  { cartTrigger.setAttribute('aria-expanded', 'false'); }
    const modal = document.getElementById('quiz-modal');
    const wishlistDrawer = document.getElementById('wishlist-drawer');
    const mobileNavDrawer = document.getElementById('mobile-nav-drawer');
    if (!modal?.classList.contains('open') && !wishlistDrawer?.classList.contains('open') && !mobileNavDrawer?.classList.contains('open')) {
      document.body.style.overflow = '';
    }
  }

  if (cartTrigger) {
    cartTrigger.addEventListener('click', e => { e.stopPropagation(); openCartDrawer(); });
  }
  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', closeCartDrawer);
  }

  /* ── AJAX: refresh cart drawer section ─────────────────── */

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?section_id=ph24-cart-drawer&_ts=' + Date.now());
      if (!res.ok) return;
      const html = await res.text();
      const parser = new DOMParser();
      const doc    = parser.parseFromString(html, 'text/html');

      const newDrawer     = doc.getElementById('cart-drawer');
      const currentDrawer = document.getElementById('cart-drawer');
      if (newDrawer && currentDrawer) {
        const wasOpen = currentDrawer.classList.contains('open');
        currentDrawer.innerHTML = newDrawer.innerHTML;
        if (wasOpen) {
          currentDrawer.classList.add('open');
          currentDrawer.setAttribute('aria-hidden', 'false');
        }
      }

      // Update cart badge from hidden count element
      const countEl = doc.getElementById('ph24-cart-count');
      if (countEl) updateCartBadge(parseInt(countEl.textContent.trim(), 10) || 0);

      syncSummaryState();
    } catch (err) {
      console.error('[PH24] Cart refresh error:', err);
    }
  }

  /* ── AJAX: add to cart ──────────────────────────────────── */

  async function ajaxAddToCart(variantId, quantity = 1) {
    if (!variantId) { openCartDrawer(); return; }

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity }] })
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        console.error('[PH24] Add to cart failed:', errData.description || res.status);
      }
    } catch (err) {
      console.error('[PH24] Add to cart error:', err);
    }

    await refreshCartDrawer();
    openCartDrawer();
  }

  /* Minimal surface for other theme scripts (ph24-quiz.js) that need to
     drive the cart drawer without duplicating this logic. */
  window.PH24 = Object.assign(window.PH24 || {}, {
    openCartDrawer,
    closeCartDrawer,
    refreshCartDrawer,
    ajaxAddToCart
  });

  /* ── AJAX: update cart item quantity ───────────────────── */

  async function updateCartItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
    } catch (err) {
      console.error('[PH24] Cart update error:', err);
    }
    await refreshCartDrawer();
  }

  /* ── Discount code (applies via Shopify's /discount/<code> route) ── */

  const DISCOUNT_ATTEMPT_KEY = 'ph24_discount_attempt';

  function showDiscountMessage(state, text) {
    const msg = document.getElementById('cart-discount-msg');
    if (!msg) return;
    msg.dataset.state = state;
    msg.textContent = text;
    msg.style.display = text ? 'flex' : 'none';
  }

  function applyDiscountCode(code) {
    code = (code || '').trim();
    if (!code) return;
    sessionStorage.setItem(DISCOUNT_ATTEMPT_KEY, code);

    const url = new URL(window.location.href);
    url.searchParams.set('cart', 'open');

    const target = window.location.origin + '/discount/' + encodeURIComponent(code)
      + '?redirect=' + encodeURIComponent(url.pathname + url.search);
    window.location.href = target;
  }

  // Resume after a /discount/<code> redirect: reopen drawer, report result
  (function handleDiscountReturn() {
    const params = window.location.search;
    if (params.indexOf('cart=open') !== -1) {
      openCartDrawer();
      const url = new URL(window.location.href);
      url.searchParams.delete('cart');
      window.history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + url.hash);
    }

    const attempted = sessionStorage.getItem(DISCOUNT_ATTEMPT_KEY);
    if (attempted) {
      sessionStorage.removeItem(DISCOUNT_ATTEMPT_KEY);
      const countEl = document.getElementById('ph24-discount-count');
      const applied = countEl && parseInt(countEl.textContent.trim(), 10) > 0;
      if (applied) {
        showDiscountMessage('success', 'Kod „' + attempted + '” został zastosowany.');
      } else {
        showDiscountMessage('error', 'Kod „' + attempted + '” jest nieprawidłowy lub wygasł.');
      }
    }
  })();

  /* ── Event delegation for dynamic cart content ─────────── */

  document.body.addEventListener('click', event => {

    // Cart close button (re-rendered after each refresh)
    if (event.target.closest('.cart-close') && document.getElementById('cart-drawer')?.contains(event.target.closest('.cart-close'))) {
      closeCartDrawer();
      return;
    }

    // Quantity minus
    const qtyMinus = event.target.closest('.qty-minus');
    if (qtyMinus) {
      event.preventDefault();
      const key = qtyMinus.dataset.key;
      const qty = parseInt(qtyMinus.dataset.qty, 10);
      if (key) updateCartItem(key, qty >= 0 ? qty : 0);
      return;
    }

    // Quantity plus
    const qtyPlus = event.target.closest('.qty-plus');
    if (qtyPlus) {
      event.preventDefault();
      const key = qtyPlus.dataset.key;
      const qty = parseInt(qtyPlus.dataset.qty, 10);
      if (key) updateCartItem(key, qty);
      return;
    }

    // Add to cart buttons in grids / home (btn-add class)
    const btnAdd = event.target.closest('.btn-add');
    if (btnAdd) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = btnAdd.dataset.variantId;
      ajaxAddToCart(variantId, 1);
      return;
    }

    // Hero product mini add buttons (.hp-add, .add)
    const btnMiniAdd = event.target.closest('.hp-add, .add');
    if (btnMiniAdd) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = btnMiniAdd.dataset.variantId;
      ajaxAddToCart(variantId, 1);
      return;
    }

    // Product page main buy button
    if (event.target.closest('#buybox-add-to-cart')) {
      event.preventDefault();
      const btn = event.target.closest('#buybox-add-to-cart');
      const variantId = btn.dataset.variantId;
      const selectedBundle = document.querySelector('.bundle-option.selected input[type=radio]');
      const qty = selectedBundle ? parseInt(selectedBundle.value, 10) || 1 : 1;
      ajaxAddToCart(variantId, qty);
      return;
    }

    // Sticky buy bar button
    if (event.target.closest('#sticky-add-to-cart')) {
      event.preventDefault();
      const btn = event.target.closest('#sticky-add-to-cart');
      const variantId = btn.dataset.variantId;
      ajaxAddToCart(variantId, 1);
      return;
    }

    // Cart recommend "Dodaj" button (re-rendered after each refresh)
    const recommendAdd = event.target.closest('.cart-recommend-add');
    if (recommendAdd) {
      event.preventDefault();
      const variantId = recommendAdd.dataset.variant;
      ajaxAddToCart(variantId, 1);
      return;
    }

    // Discount code "Zastosuj" button (re-rendered after each refresh)
    if (event.target.closest('#cart-discount-apply')) {
      event.preventDefault();
      const input = document.getElementById('cart-discount-input');
      if (input) applyDiscountCode(input.value);
      return;
    }

    // Checkout link — gate on consent, then navigate explicitly to /checkout
    const checkoutLink = event.target.closest('#summary-link');
    if (checkoutLink) {
      event.preventDefault();
      if (checkoutLink.classList.contains('disabled')) {
        const consentLabel = document.querySelector('.cart-consent');
        if (consentLabel) {
          consentLabel.classList.add('attention');
          consentLabel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => consentLabel.classList.remove('attention'), 700);
        }
      } else {
        // routes.checkout_url can render empty (preview / section-render context),
        // so navigate to the literal checkout route which always resolves.
        const href = checkoutLink.getAttribute('href');
        window.location.href = (href && href.trim() !== '') ? href : '/checkout';
      }
      return;
    }

    // Clickable product cards (navigate to product page)
    const productCard = event.target.closest('.product-card[data-card-url]');
    if (productCard) {
      // Skip if click was on an interactive element
      if (event.target.closest('button, a, input, label, select')) return;
      window.location.href = productCard.dataset.cardUrl;
      return;
    }

  });

  // Consent checkbox — event delegation (element re-created on cart refresh)
  document.body.addEventListener('change', event => {
    if (event.target.id === 'cart-consent') {
      syncSummaryState();
    }
  });

  // Discount code input — submit on Enter (element re-created on cart refresh)
  document.body.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.id === 'cart-discount-input') {
      event.preventDefault();
      applyDiscountCode(event.target.value);
    }
  });

  // Initial consent state
  syncSummaryState();

  /* ── Mega menu ──────────────────────────────────────────── */

  const megaMenu     = document.getElementById('mega-menu');
  const menuTriggers = document.querySelectorAll('.nav-menu-trigger');
  const menuPanels   = document.querySelectorAll('[data-menu-panel]');

  function closeMegaMenu() {
    if (!megaMenu) return;
    megaMenu.classList.remove('open');
    menuTriggers.forEach(t => { t.classList.remove('active'); t.setAttribute('aria-expanded', 'false'); });
    menuPanels.forEach(p => p.classList.remove('active'));
  }

  function openMegaMenu(name) {
    if (!megaMenu) return;
    megaMenu.classList.add('open');
    menuTriggers.forEach(t => {
      const active = t.dataset.menu === name;
      t.classList.toggle('active', active);
      t.setAttribute('aria-expanded', String(active));
    });
    menuPanels.forEach(p => p.classList.toggle('active', p.dataset.menuPanel === name));
  }

  menuTriggers.forEach(t => {
    t.addEventListener('click', e => {
      e.stopPropagation();
      t.classList.contains('active') ? closeMegaMenu() : openMegaMenu(t.dataset.menu);
    });
  });

  if (megaMenu) megaMenu.addEventListener('click', e => e.stopPropagation());
  document.addEventListener('click', closeMegaMenu);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeMegaMenu(); closeCartDrawer(); closeWishlistDrawer(); closeMobileNav(); closeQuiz(); } });

  /* ── Mobile nav drawer ──────────────────────────────────── */

  const mobileNavTrigger  = document.getElementById('mobile-nav-trigger');
  const mobileNavDrawer   = document.getElementById('mobile-nav-drawer');
  const mobileNavBackdrop = document.getElementById('mobile-nav-backdrop');
  const mobileNavClose    = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    closeMegaMenu();
    closeCartDrawer();
    closeWishlistDrawer();
    if (mobileNavDrawer)   { mobileNavDrawer.classList.add('open');   mobileNavDrawer.setAttribute('aria-hidden', 'false'); }
    if (mobileNavBackdrop) { mobileNavBackdrop.classList.add('open'); }
    if (mobileNavTrigger)  { mobileNavTrigger.setAttribute('aria-expanded', 'true'); }
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (mobileNavDrawer)   { mobileNavDrawer.classList.remove('open');   mobileNavDrawer.setAttribute('aria-hidden', 'true'); }
    if (mobileNavBackdrop) { mobileNavBackdrop.classList.remove('open'); }
    if (mobileNavTrigger)  { mobileNavTrigger.setAttribute('aria-expanded', 'false'); }
    const modal = document.getElementById('quiz-modal');
    if (!cartDrawer?.classList.contains('open') && !document.getElementById('wishlist-drawer')?.classList.contains('open') && !modal?.classList.contains('open')) {
      document.body.style.overflow = '';
    }
  }

  if (mobileNavTrigger)  mobileNavTrigger.addEventListener('click', e => { e.stopPropagation(); openMobileNav(); });
  if (mobileNavClose)    mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavBackdrop) mobileNavBackdrop.addEventListener('click', closeMobileNav);
  if (mobileNavDrawer)   mobileNavDrawer.addEventListener('click', e => e.stopPropagation());

  /* ── Wishlist / Favorites drawer ────────────────────────── */

  const wishlistTrigger     = document.getElementById('wishlist-trigger');
  const wishlistDrawer      = document.getElementById('wishlist-drawer');
  const wishlistBackdrop    = document.getElementById('wishlist-backdrop');
  const wishlistClose       = document.querySelector('.wishlist-close');
  const wishlistBadge       = document.getElementById('wishlist-badge');
  const wishlistItemsEl     = document.getElementById('wishlist-items');
  const wishlistEmptyEl     = document.getElementById('wishlist-empty');
  const wishlistSortBarEl   = document.getElementById('wishlist-sort-bar');
  const wishlistSortSelect  = document.getElementById('wishlist-sort-select');

  if (wishlistSortSelect) {
    wishlistSortSelect.addEventListener('change', () => updateWishlistUI());
  }

  function openWishlistDrawer() {
    closeMegaMenu();
    closeCartDrawer();
    closeMobileNav();
    if (wishlistDrawer)   { wishlistDrawer.classList.add('open');   wishlistDrawer.setAttribute('aria-hidden', 'false'); }
    if (wishlistBackdrop) { wishlistBackdrop.classList.add('open'); }
    if (wishlistTrigger)  { wishlistTrigger.setAttribute('aria-expanded', 'true'); }
    document.body.style.overflow = 'hidden';
  }

  function closeWishlistDrawer() {
    if (wishlistDrawer)   { wishlistDrawer.classList.remove('open');   wishlistDrawer.setAttribute('aria-hidden', 'true'); }
    if (wishlistBackdrop) { wishlistBackdrop.classList.remove('open'); }
    if (wishlistTrigger)  { wishlistTrigger.setAttribute('aria-expanded', 'false'); }
    const modal = document.getElementById('quiz-modal');
    const mobileNavDrawer = document.getElementById('mobile-nav-drawer');
    if (!modal?.classList.contains('open') && !cartDrawer?.classList.contains('open') && !mobileNavDrawer?.classList.contains('open')) {
      document.body.style.overflow = '';
    }
  }

  if (wishlistTrigger)  wishlistTrigger.addEventListener('click',  e => { e.stopPropagation(); openWishlistDrawer(); });
  if (wishlistClose)    wishlistClose.addEventListener('click', closeWishlistDrawer);
  if (wishlistBackdrop) wishlistBackdrop.addEventListener('click', closeWishlistDrawer);

  function getFavorites() {
    try { return JSON.parse(localStorage.getItem('ph24-favorites') || '[]'); }
    catch { return []; }
  }
  function saveFavorites(favs) {
    try { localStorage.setItem('ph24-favorites', JSON.stringify(favs)); }
    catch { /* storage full */ }
  }

  function toggleFavorite(product) {
    let favs  = getFavorites();
    const idx = favs.findIndex(f => String(f.id) === String(product.id));
    if (idx > -1) favs.splice(idx, 1);
    else favs.push(product);
    saveFavorites(favs);
    updateWishlistUI();
    syncHeartButtonsState();
  }

  function parsePrice(str) {
    if (!str) return 0;
    return parseFloat(String(str).replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
  }

  function updateWishlistUI() {
    const favs = getFavorites();

    if (wishlistBadge) {
      wishlistBadge.textContent = favs.length;
      wishlistBadge.style.display = favs.length > 0 ? 'grid' : 'none';
    }

    if (favs.length === 0) {
      if (wishlistEmptyEl)   wishlistEmptyEl.style.display   = 'flex';
      if (wishlistSortBarEl) wishlistSortBarEl.style.display = 'none';
      if (wishlistItemsEl) { wishlistItemsEl.style.display = 'none'; wishlistItemsEl.innerHTML = ''; }
      return;
    }

    if (wishlistEmptyEl)   wishlistEmptyEl.style.display   = 'none';
    if (wishlistSortBarEl) wishlistSortBarEl.style.display = 'flex';
    if (!wishlistItemsEl)  return;

    wishlistItemsEl.style.display = 'flex';
    wishlistItemsEl.innerHTML = '';

    const sort   = wishlistSortSelect ? wishlistSortSelect.value : 'default';
    let   sorted = [...favs];
    if      (sort === 'title-asc')   sorted.sort((a, b) => a.title.localeCompare(b.title));
    else if (sort === 'title-desc')  sorted.sort((a, b) => b.title.localeCompare(a.title));
    else if (sort === 'price-asc')   sorted.sort((a, b) => parsePrice(a.price) - parsePrice(b.price));
    else if (sort === 'price-desc')  sorted.sort((a, b) => parsePrice(b.price) - parsePrice(a.price));

    const SVG_PH = [
      `<svg class="ph" viewBox="0 0 48 64" aria-hidden="true"><rect x="12" y="6" width="24" height="52" rx="4"/><line x1="19" y1="17" x2="29" y2="17"/><line x1="19" y1="25" x2="27" y2="25"/><circle cx="24" cy="40" r="6"/></svg>`,
      `<svg class="ph" viewBox="0 0 48 64" aria-hidden="true"><circle cx="24" cy="24" r="12"/><path d="M16 44h16"/></svg>`,
      `<svg class="ph" viewBox="0 0 48 64" aria-hidden="true"><path d="M18 10h12l3 12H15l3-12z"/><path d="M15 22c0 28 3 38 9 38s9-10 9-38"/></svg>`,
      `<svg class="ph" viewBox="0 0 48 64" aria-hidden="true"><rect x="12" y="6" width="24" height="52" rx="4"/><circle cx="24" cy="36" r="7"/></svg>`
    ];

    sorted.forEach(prod => {
      const mediaHtml = prod.image
        ? `<img src="${prod.image}" alt="${prod.title}" loading="lazy">`
        : SVG_PH[parseInt(prod.svgIndex, 10) % 4 || 0];

      const item = document.createElement('div');
      item.className = 'wishlist-item';
      item.innerHTML = `
        <div class="wishlist-item-media pm-${prod.colorScheme || 'green'}">${mediaHtml}</div>
        <div class="wishlist-item-main">
          <span class="wishlist-item-brand">${prod.vendor || 'Medfuture'}</span>
          <a href="${prod.url || '#'}" class="wishlist-item-name">${prod.title}</a>
          <div class="wishlist-item-price">${prod.price}</div>
        </div>
        <div class="wishlist-item-actions">
          <button type="button" class="wishlist-item-remove" aria-label="Usuń z ulubionych">×</button>
          <button type="button" class="wishlist-item-add" data-variant-id="${prod.variantId || ''}">
            <svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;stroke-width:2.2;" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
            + Koszyk
          </button>
        </div>`;

      item.querySelector('.wishlist-item-remove').addEventListener('click', () => toggleFavorite(prod));
      item.querySelector('.wishlist-item-add').addEventListener('click', () => {
        const vid = prod.variantId;
        if (vid) { closeWishlistDrawer(); ajaxAddToCart(vid, 1); }
        else     { closeWishlistDrawer(); openCartDrawer(); }
      });

      wishlistItemsEl.appendChild(item);
    });
  }

  function syncHeartButtonsState() {
    const ids = getFavorites().map(f => String(f.id));
    document.querySelectorAll('.product-wishlist, .product-wishlist-toggle').forEach(btn => {
      const isFav = ids.includes(String(btn.dataset.id));
      btn.classList.toggle('active', isFav);
      btn.setAttribute('aria-pressed', String(isFav));
    });
  }

  // Wishlist heart toggle — event delegation
  document.body.addEventListener('click', event => {
    const btn = event.target.closest('.product-wishlist, .product-wishlist-toggle');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggleFavorite({
      id:          btn.dataset.id,
      handle:      btn.dataset.handle,
      title:       btn.dataset.title,
      vendor:      btn.dataset.vendor,
      price:       btn.dataset.price,
      url:         btn.dataset.url,
      colorScheme: btn.dataset.colorScheme,
      image:       btn.dataset.image,
      svgIndex:    btn.dataset.imageSvgIndex,
      variantId:   btn.dataset.variantId || ''
    });
  });

  updateWishlistUI();
  syncHeartButtonsState();

  /* ── Quiz modal ─────────────────────────────────────────── */

  // Build quizConfig from inline JSON blocks rendered by ph24-hero.liquid
  const quizConfig = {};
  document.querySelectorAll('script.ph24-quiz-chip-cfg').forEach(el => {
    try { quizConfig[el.dataset.need] = JSON.parse(el.textContent); }
    catch { /* malformed block — skip */ }
  });

  let currentNeed = null;
  let currentStep = 0;
  const answers   = [];
  const modal     = document.getElementById('quiz-modal');

  function openQuiz(need) {
    if (!modal) return;
    currentNeed = need;
    currentStep = 0;
    answers.length = 0;
    renderQuizStep();
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeQuiz() {
    if (!modal) return;
    modal.classList.remove('open');
    if (!cartDrawer?.classList.contains('open') && !wishlistDrawer?.classList.contains('open')) {
      document.body.style.overflow = '';
    }
  }

  function renderQuizStep() {
    const cfg  = quizConfig[currentNeed];
    const step = cfg.questions[currentStep];
    const titleEl    = document.getElementById('quiz-title');
    const questionEl = document.getElementById('quiz-question');
    const countEl    = document.getElementById('quiz-count');
    const backBtn    = document.querySelector('.quiz-back');
    const optionsEl  = document.getElementById('quiz-options');

    if (titleEl)    titleEl.textContent    = cfg.title;
    if (questionEl) questionEl.textContent = step.q;
    if (countEl)    countEl.textContent    = `Pytanie ${currentStep + 1} z 3`;
    if (backBtn)    backBtn.classList.toggle('visible', currentStep > 0);

    document.querySelectorAll('.quiz-progress span').forEach((b, i) => b.classList.toggle('active', i <= currentStep));

    if (optionsEl) {
      optionsEl.innerHTML = '';
      step.options.forEach(opt => {
        const btn = document.createElement('button');
        btn.className = 'quiz-option';
        btn.type = 'button';
        btn.innerHTML = `${opt} <span>›</span>`;
        btn.addEventListener('click', () => {
          answers.push(opt);
          if (currentStep < 2) { currentStep++; renderQuizStep(); }
          else {
            const dest = new URL(cfg.collection, window.location.origin);
            dest.searchParams.set('ans', answers.join('|'));
            window.location.href = dest.toString();
          }
        });
        optionsEl.appendChild(btn);
      });
    }
  }

  document.querySelectorAll('[data-quiz-need]').forEach(btn => btn.addEventListener('click', () => openQuiz(btn.dataset.quizNeed)));

  const quizClose = document.querySelector('.quiz-close');
  const quizBack  = document.querySelector('.quiz-back');
  if (quizClose) quizClose.addEventListener('click', closeQuiz);
  if (quizBack)  quizBack.addEventListener('click', () => { if (currentStep > 0) { currentStep--; answers.pop(); renderQuizStep(); } });
  if (modal)     modal.addEventListener('click', e => { if (e.target === modal) closeQuiz(); });

  /* ── Bundle selector (product page) ────────────────────── */

  const bundleOptions = document.querySelectorAll('.bundle-option');
  if (bundleOptions.length) {
    bundleOptions.forEach(opt => {
      opt.addEventListener('click', () => {
        bundleOptions.forEach(o => o.classList.remove('selected'));
        opt.classList.add('selected');
        const radio = opt.querySelector('input[type=radio]');
        if (radio) radio.checked = true;
      });
    });
  }

  /* ── Tab pills (product page) ───────────────────────────── */

  document.querySelectorAll('.tab-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      const tab = pill.dataset.tab;
      if (!tab) return;
      document.querySelectorAll('.tab-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      document.querySelectorAll('.tab-panel').forEach(panel => panel.classList.remove('active'));
      const target = document.getElementById(`tab-${tab}`);
      if (target) target.classList.add('active');
    });
  });

  /* ── FAQ accordion (product page) ──────────────────────── */

  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq-item');
      if (!item) return;
      const isOpen = item.classList.contains('open');

      item.parentElement.querySelectorAll('.faq-item.open').forEach(i => {
        i.classList.remove('open');
        const t = i.querySelector('.faq-toggle');
        if (t) t.textContent = '+';
      });

      if (!isOpen) {
        item.classList.add('open');
        const toggleBtn = q.querySelector('.faq-toggle');
        if (toggleBtn) toggleBtn.textContent = '−';
      }
    });
  });

  /* ── Gallery thumbnails (product page) ─────────────────── */

  const galleryMain   = document.querySelector('.gallery-main');
  const galleryThumbs = document.querySelectorAll('.thumb');
  if (galleryMain && galleryThumbs.length) {
    galleryThumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        galleryThumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const img = thumb.querySelector('img');
        const mainImg = galleryMain.querySelector('img');
        if (img && mainImg) {
          mainImg.src = img.src.replace(/width=\d+/, 'width=600');
          mainImg.alt = img.alt;
        }
      });
    });
  }

  /* ── Dispatch countdown (product page) ─────────────────── */
  /* Schedule: Mon–Fri cutoff from data-cutoff-weekday, Saturday cutoff
     from data-cutoff-saturday, Sunday has no dispatch. */

  const countdownEl = document.getElementById('dispatch-countdown');
  const cutoffEl    = document.getElementById('dispatch-cutoff-time');
  const dayWordEl   = document.getElementById('dispatch-day-word');
  const badgeEl     = document.getElementById('dispatch-time-badge');
  const titleEl     = document.querySelector('.dispatch-title');

  if (countdownEl && cutoffEl && titleEl) {
    const weekdayCutoff   = titleEl.dataset.cutoffWeekday || '15:00';
    const saturdayCutoff  = titleEl.dataset.cutoffSaturday || '11:00';
    const dayWords  = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];
    const dayBadges = ['NIE', 'PON', 'WT', 'ŚR', 'CZW', 'PT', 'SOB'];

    function cutoffForDay(dow) {
      if (dow === 0) return null; // Sunday — no dispatch
      if (dow === 6) return saturdayCutoff;
      return weekdayCutoff;
    }

    function nextCutoff(now) {
      for (let add = 0; add <= 7; add++) {
        const day = new Date(now);
        day.setDate(day.getDate() + add);
        const cutoffStr = cutoffForDay(day.getDay());
        if (!cutoffStr) continue;
        const [h, m] = cutoffStr.split(':').map(Number);
        day.setHours(h, m, 0, 0);
        if (day > now) return { date: day, cutoffStr, daysAhead: add };
      }
      return null;
    }

    function tick() {
      const now  = new Date();
      const next = nextCutoff(now);
      if (!next) return;

      const diff = next.date - now;
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      // data-format="clock" renders the compact 05 : 58 : 35 style.
      countdownEl.textContent = countdownEl.dataset.format === 'clock'
        ? `${String(h).padStart(2, '0')} : ${String(m).padStart(2, '0')} : ${String(s).padStart(2, '0')}`
        : `${h} godz. ${String(m).padStart(2, '0')} min. ${String(s).padStart(2, '0')} sek.`;
      cutoffEl.textContent = next.cutoffStr;

      if (next.daysAhead === 0) {
        if (badgeEl) badgeEl.textContent = 'DZIŚ';
        if (dayWordEl) dayWordEl.textContent = 'dzisiaj';
      } else if (next.daysAhead === 1) {
        if (badgeEl) badgeEl.textContent = 'JUTRO';
        if (dayWordEl) dayWordEl.textContent = 'jutro';
      } else {
        const dow = next.date.getDay();
        if (badgeEl) badgeEl.textContent = dayBadges[dow];
        if (dayWordEl) dayWordEl.textContent = dayWords[dow];
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ── Cart drawer dispatch countdown (global; re-queries each tick
       so it survives the cart drawer innerHTML re-render) ──────── */
  (function cartDispatchCountdown() {
    const dayWords = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];

    function cutoffForDay(dow, wk, sat) {
      if (dow === 0) return null;      // Sunday — no dispatch
      if (dow === 6) return sat;
      return wk;
    }
    function nextCutoff(now, wk, sat) {
      for (let add = 0; add <= 7; add++) {
        const day = new Date(now);
        day.setDate(day.getDate() + add);
        const cutoffStr = cutoffForDay(day.getDay(), wk, sat);
        if (!cutoffStr) continue;
        const [h, m] = cutoffStr.split(':').map(Number);
        day.setHours(h, m, 0, 0);
        if (day > now) return { date: day, cutoffStr, daysAhead: add };
      }
      return null;
    }
    function tick() {
      const wrap = document.querySelector('.cart-dispatch[data-cutoff-weekday]');
      if (!wrap) return;
      const cdEl  = document.getElementById('cart-dispatch-countdown');
      const cutEl = document.getElementById('cart-dispatch-cutoff');
      const dayEl = document.getElementById('cart-dispatch-day');
      const wk  = wrap.dataset.cutoffWeekday  || '15:00';
      const sat = wrap.dataset.cutoffSaturday || '11:00';
      const now  = new Date();
      const next = nextCutoff(now, wk, sat);
      if (!next) { if (cdEl) cdEl.textContent = '—'; return; }
      const diff = next.date - now;
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (cdEl)  cdEl.textContent  = `${h} godz. ${String(m).padStart(2, '0')} min. ${String(s).padStart(2, '0')} sek.`;
      if (cutEl) cutEl.textContent = next.cutoffStr;
      if (dayEl) dayEl.textContent = next.daysAhead === 0 ? 'dziś' : (next.daysAhead === 1 ? 'jutro' : dayWords[next.date.getDay()]);
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ── Collection sort ────────────────────────────────────── */

  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── View toggle (collection grid) ─────────────────────── */

  const viewButtons = document.querySelectorAll('.view-btn[data-view]');
  const productsGrid = document.querySelector('.products-grid');

  if (viewButtons.length && productsGrid) {
    function applyView(view) {
      productsGrid.classList.toggle('list-view', view === 'list');
      viewButtons.forEach(b => {
        const isActive = b.dataset.view === view;
        b.classList.toggle('active', isActive);
        b.setAttribute('aria-pressed', String(isActive));
      });
      try { localStorage.setItem('ph24-collection-view', view); } catch (e) { /* private mode */ }
    }

    viewButtons.forEach(btn => {
      btn.addEventListener('click', () => applyView(btn.dataset.view));
    });

    let saved = null;
    try { saved = localStorage.getItem('ph24-collection-view'); } catch (e) { /* private mode */ }
    if (saved === 'list' || saved === 'grid') applyView(saved);
  }

  /* ── Cat-desc expand/collapse (collection header) ──────── */

  const descToggle = document.querySelector('.cat-desc-toggle');
  const catDesc    = document.querySelector('.cat-desc');

  if (descToggle && catDesc) {
    const moreLabel = descToggle.querySelector('.toggle-text')?.textContent.trim() || 'Więcej';
    const lessLabel = descToggle.dataset.lessLabel || 'Mniej';

    // Only offer the toggle when the copy is actually taller than the clamp.
    function syncToggleVisibility() {
      if (catDesc.classList.contains('expanded')) return;
      const overflows = catDesc.scrollHeight > catDesc.clientHeight + 4;
      descToggle.hidden = !overflows;
      catDesc.classList.toggle('is-clamped', overflows);
    }

    descToggle.addEventListener('click', function () {
      const expanded = catDesc.classList.toggle('expanded');
      catDesc.classList.toggle('is-clamped', !expanded);
      this.setAttribute('aria-expanded', String(expanded));
      this.classList.toggle('active', expanded);
      const textEl = this.querySelector('.toggle-text');
      if (textEl) textEl.textContent = expanded ? lessLabel : moreLabel;
    });

    syncToggleVisibility();
    // Fonts and images can land after first paint and change the height.
    window.addEventListener('load', syncToggleVisibility);
    window.addEventListener('resize', syncToggleVisibility);
  }

  /* ── Search query builder ────────────────────────────────
     Shopify matches whole words, so the last token gets a "*" — bez tego
     wpisanie "gli" nie znajduje nic, dopóki nie dopisze się całego "Glicyna".

     Prefiksu "title:" już NIE dodajemy. Shopify przestał honorować go razem
     z gwiazdką — "title:gli*" zwraca zero wyników, choć samo "gli*" działa,
     a "title:glicyna" (pełne słowo) nadal działa. Zawężenie do nazwy produktu
     robimy więc sami: w podpowiedziach filtrujemy odpowiedź, a na stronie
     wyników filtruje szablon. */

  var PH24_SEARCH_MIN_CHARS = 3;

  function ph24BuildSearchQuery(term) {
    var q = (term || '').trim();
    if (!q) return '';
    // The visitor typed their own field prefix (e.g. "vendor:Medfuture") — respect it.
    if (/^\w+:/.test(q)) return q;

    var parts = q.split(/\s+/);
    var last = parts[parts.length - 1];
    if (last && last.indexOf('*') === -1) parts[parts.length - 1] = last + '*';
    return parts.join(' ');
  }

  /* Porównanie odporne na wielkość liter i polskie znaki — żeby "zoladek"
     trafiał w "żołądek", a "chlor" nie trafiał w "chłodząca". */
  function ph24Norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ł/g, 'l');
  }

  /* Czy nazwa produktu zawiera wszystkie wpisane słowa. */
  function ph24TitleMatches(title, term) {
    var hay = ph24Norm(title);
    return ph24Norm(term).split(/\s+/).filter(Boolean)
      .every(function (w) { return hay.indexOf(w) !== -1; });
  }

  /* ── Wysłanie formularza wyszukiwania ──
     Do adresu trafia zapytanie z gwiazdką. Zawężenie do nazwy produktu
     robi szablon wyników — odczytuje frazę z search.terms. */

  document.addEventListener('submit', event => {
    const form = event.target.closest('form[data-search-scope="title"]');
    if (!form) return;

    const input = form.querySelector('input[name="q"]');
    const term  = (input?.value || '').trim();
    if (!term) return;

    event.preventDefault();
    const params = new URLSearchParams();
    params.set('q', ph24BuildSearchQuery(term));
    params.set('type', 'product');
    window.location.href = (form.getAttribute('action') || '/search') + '?' + params.toString();
  });

  /* ── Search autocomplete ────────────────────────────────── */

  const searchInput = document.querySelector('.header .search input[type="search"]');
  const searchForm  = document.querySelector('.header .search');

  if (searchInput && searchForm) {
    searchInput.setAttribute('autocomplete', 'off');

    const suggestionsDiv = document.createElement('div');
    suggestionsDiv.className = 'search-suggestions';
    suggestionsDiv.id        = 'search-suggestions';
    suggestionsDiv.style.display = 'none';
    searchForm.appendChild(suggestionsDiv);

    let debounceTimer;
    const SVG_FALLBACK = `<svg class="ph" viewBox="0 0 48 64" aria-hidden="true"><rect x="12" y="6" width="24" height="52" rx="4"/><circle cx="24" cy="36" r="7"/></svg>`;

    const escHtml = str => String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    // Shopify CDN resizes server-side; without it the browser downscales the full
    // 780px original into a ~48px box and the result looks soft.
    const cdnImage = (url, w) => {
      try {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('width', String(w));
        return u.toString();
      } catch (e) { return url; }
    };

    // /search/suggest.json returns price as a plain string ("35.03"), not cents.
    const formatPrice = raw => {
      if (raw == null || raw === '') return '';
      if (typeof raw === 'number') return (raw / 100).toFixed(2).replace('.', ',') + ' zł';
      const s = String(raw).trim();
      if (/[^\d\s.,]/.test(s)) return s;
      const n = parseFloat(s.replace(/\s/g, '').replace(',', '.'));
      return isFinite(n) ? n.toFixed(2).replace('.', ',') + ' zł' : s;
    };

    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const q = searchInput.value.trim();
      if (q.length < PH24_SEARCH_MIN_CHARS) { suggestionsDiv.style.display = 'none'; suggestionsDiv.innerHTML = ''; return; }

      debounceTimer = setTimeout(async () => {
        try {
          const scoped = ph24BuildSearchQuery(q);
          /* Pobieramy z zapasem, bo poniżej odsiewamy trafienia spoza nazwy
             produktu — Shopify szuka też w opisie, przez co np. „chlor”
             wyciągało maść chłodzącą. */
          const res = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(scoped)}` +
            `&resources[type]=product&resources[limit]=10`
          );
          if (!res.ok) return;
          const data = await res.json();
          const all  = data.resources?.results?.products || [];

          const onlyTitle = searchForm.dataset.searchScope === 'title' && !/^\w+:/.test(q);
          const matched   = onlyTitle ? all.filter(p => ph24TitleMatches(p.title, q)) : all;
          /* Gdyby filtr wyciął wszystko, lepiej pokazać cokolwiek sensownego
             niż pustkę. */
          const products  = (matched.length ? matched : all).slice(0, 5);

          if (!products.length) {
            suggestionsDiv.innerHTML = `<div class="suggestion-empty">Brak wyników dla „${escHtml(q)}"</div>`;
            suggestionsDiv.style.display = 'flex';
            return;
          }

          suggestionsDiv.innerHTML = '';
          products.forEach(prod => {
            const item = document.createElement('a');
            item.href      = prod.url;
            item.className = 'suggestion-item';

            const mediaHtml = prod.image
              ? `<img src="${escHtml(cdnImage(prod.image, 96))}" srcset="${escHtml(cdnImage(prod.image, 96))} 1x, ${escHtml(cdnImage(prod.image, 192))} 2x" width="48" height="48" alt="${escHtml(prod.title)}" loading="lazy" decoding="async">`
              : SVG_FALLBACK;

            item.innerHTML = `
              <div class="suggestion-media">${mediaHtml}</div>
              <div class="suggestion-info">
                <span class="suggestion-brand">${escHtml(prod.vendor || 'Medfuture')}</span>
                <span class="suggestion-title">${escHtml(prod.title)}</span>
              </div>
              <div class="suggestion-price">${escHtml(formatPrice(prod.price))}</div>`;

            suggestionsDiv.appendChild(item);
          });

          suggestionsDiv.style.display = 'flex';
        } catch (err) {
          console.error('[PH24] Search suggest error:', err);
        }
      }, 250);
    });

    document.addEventListener('click', e => {
      if (!searchForm.contains(e.target)) suggestionsDiv.style.display = 'none';
    });
  }

  /* ── Filter checkboxes (static collection sidebar) ──────── */

  document.querySelectorAll('.filter-option').forEach(opt => {
    opt.addEventListener('click', () => opt.querySelector('.filter-check')?.classList.toggle('checked'));
  });

  document.querySelectorAll('.filter-group-title').forEach(title => {
    title.addEventListener('click', () => title.classList.toggle('open'));
  });

  document.querySelectorAll('.filter-pill button').forEach(btn => {
    btn.addEventListener('click', () => btn.closest('.filter-pill')?.remove());
  });

  /* ── Quick path chips ───────────────────────────────────── */

  document.querySelectorAll('.quick-chip').forEach(chip => {
    chip.addEventListener('click', () => {
      document.querySelectorAll('.quick-chip').forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
    });
  });

});
